<div class="special-instructions mb-3" *ngIf="specialInstructions">
  <p class="special-instructions__label f-14 primary-font-normal">Special Request</p>
  <p class="special-instructions__text f-14 primary-font-normal">{{ specialInstructions }}</p>
</div>

<ng-container *ngFor="let item of dishes | keyvalue">
  <article
    class="card border-radius-3 mb-4"
    [ngClass]="{ 'border-0 px-2': inExpansionPanel }"
  >
    <div class="food__header mb-0 p-3">
      <p class="mb-0 f-14 primary-font-bold">
        {{ item?.key | changeDishText }}
      </p>
    </div>

    <ng-container *ngFor="let meal of item?.value; index as mealIndex">
      <app-order-item
        [isSuccessPage]="isSuccessPage"
        [meal]="meal"
        (sendMealInfo)="handleMealAction($event, item?.key, mealIndex)"
      ></app-order-item>
    </ng-container>

    <div
      class="food__actions"
      [ngClass]="{ 'border-top-0 p-0': isSuccessPage, 'p-3': !isSuccessPage }"
    >
      <!-- <div class="trash p-2">
        <i class="fa fa-trash text-danger"></i>
      </div> -->
      <div *ngIf="!isSuccessPage" class="add-to-dish w-100">
        <button
          class="btn btn-add-to-dish btn-block f-14 primary-font-normal"
          (click)="addMealToDish(item?.key)"
        >
          <img src="/assets/icons/add-to-dish.svg" alt="" class="mr-2" />
          Add items to this dish
        </button>
      </div>
    </div>
  </article>
</ng-container>
